export default "__VITE_ASSET__$qcdCpj2__"